module.exports = __webpack_public_path__ + "static/media/Analysion-Website-Logo.32f79267.png";